import React from 'react';
import PropTypes from 'prop-types';
import AccordionMessage from '../../common/AccordionMessage';
import {FormattedMessage} from 'react-intl';

class SavePaletteMessage extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        currentInputValue: ""
      }
    }




    render() {
    return(
    <AccordionMessage header={<FormattedMessage id={'editbreak.colors.savePaletteHeader'}/>}
                      className='db-info'
                      hasError={this.props.hasError}
                      formError={this.props.formError}
                      wasSuccess={this.props.successfulPaletteCreation}
                      actions={[
                        {
                          label: <FormattedMessage id={'editbreak.colors.savePalette'}/>, //<-Change depending on new status.
                          type: 'button',
                          action: () => {
                            this.props.savePalette(this.props.breakId,this.state.currentInputValue);
                          }
                        }
                      ]}
                      inputs={[
                        {
                          label:<FormattedMessage id={'editbreak.colors.paletteInputLabel'}/>,
                          placeholderKey: 'editbreak.colors.paletteInputPlaceHolder',
                          required: false,
                          error: {
                            errorCode: "validation.DuplicatePalette"
                          },
                          onChange: (event, data) => this.setState({
                            currentInputValue: data.value
                          })
                        }
                      ]}/>
                    )
                  }
}

SavePaletteMessage.propTypes = {
    breakId:PropTypes.string
};

export default SavePaletteMessage;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/SavePaletteMessage.jsx